import React, { useLayoutEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.scss";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return { width, height };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useLayoutEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

export default function Carrousel() {
  const { height, width } = useWindowDimensions();
  return (
    <Carousel
      style={{
        height: "72vh",
        width: "100vw",
        alignSelf: "center",
        justifyContent: "center",
        display: "flex",
        backgroundColor: "#fff",
      }}
      data-bs-theme="dark"
    >
      <Carousel.Item style={{ height: "100%", width: "100%" }}>
        <img
          style={{
            height: "100%",
            width: "100%",
            resize: "block",
            objectFit: "contain",
          }}
          className="d-block w-100"
          src="./../../assets/carrousel1.png"
          alt="Mhiri Store Slide 1"
        />
        <Carousel.Caption>
          <p
            style={{
              color: "#000",
              fontSize: width > 768 ? 24 : 18,
              fontWeight: "700",
              fontStyle: "italic",
            }}
          >
            Mhiri Store Phones
          </p>
          <p
            style={{
              color: "#000",
              fontSize: width > 768 ? 24 : 14,
              fontWeight: "700",
              fontStyle: "italic",
            }}
          >
            Découvrez la vie connectée – Achetez chez Mhiri Store Phones dès
            aujourd'hui !
          </p>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item style={{ height: "100%", width: "100vw" }}>
        <img
          style={{
            height: "100%",
            width: "100vw",
            resize: "block",
            objectFit: "contain",
          }}
          className="d-block w-100"
          src="./../../assets/carrousel2.jpg"
          alt="Mhiri Store Slide 2"
        />
        <Carousel.Caption>
          <p
            style={{
              color: "#000",
              fontSize: width > 768 ? 24 : 18,
              fontWeight: "700",
              fontStyle: "italic",
            }}
          >
            Mhiri Store Phones
          </p>
          <p
            style={{
              color: "#000",
              fontSize: width > 768 ? 24 : 14,
              fontWeight: "700",
              fontStyle: "italic",
            }}
          >
            Améliorez votre expérience – Commandez maintenant, à tout moment,
            n'importe où !
          </p>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item style={{ height: "100%", width: "100%" }}>
        <img
          style={{
            height: "100%",
            width: "100%",
            resize: "block",
            objectFit: "contain",
          }}
          className="d-block w-100"
          src="./../../assets/carrousel3.jpg"
          alt="Mhiri Store Slide 3"
        />
        <Carousel.Caption>
          <p
            style={{
              color: "#000",
              fontSize: width > 768 ? 24 : 18,
              fontWeight: "700",
              fontStyle: "italic",
            }}
          >
            Mhiri Store Phones
          </p>
          <p
            style={{
              color: "#000",
              fontSize: width > 768 ? 24 : 14,
              fontWeight: "700",
              fontStyle: "italic",
            }}
          >
            De notre boutique à votre poche – Commandez votre téléphone idéal
            maintenant !
          </p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}
